export default __webpack_public_path__ + "static/media/TOYOTA03.7b7256f4.png";